import { fetchAllProducts } from 'Services/ProductManagement/Features/Product/productSlice'
import { useAppDispatch, useTypedSelector } from 'Store'
import { All_PRODUCTS_COUNT_PER_REQUEST } from 'Util/constants'
import { useEffect } from 'react'

function useProducts(fetchOnInit = true) {
  const dispatch = useAppDispatch()
  const { allProducts, allProductsLoading } = useTypedSelector(state => state.product)

  const fetchAllProductsWithoutPagination = () => {
    dispatch(
      fetchAllProducts({
        bypass_pagination: true,
        count: All_PRODUCTS_COUNT_PER_REQUEST,
        has_no_tariff: true
      })
    )
  }

  useEffect(() => {
    if (fetchOnInit) fetchAllProductsWithoutPagination()
  }, [])

  return {
    allProducts,
    allProductsLoading,
    fetchAllProductsWithoutPagination
  }
}

export default useProducts
